import React from 'react';
import { Footer } from './footer';
import { Header } from './header';

interface MainLayoutProps {
  children: React.ReactNode;
}

export function MainLayout({ children }: MainLayoutProps) {
  return (
    <div className="min-h-svh flex flex-col">
      <Header />

      <main className="flex-auto">{children}</main>

      <Footer />
    </div>
  );
}
